import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["tagName", "children", "refCallback", "innerRef", "className"];
/* eslint-disable react/prop-types */
import * as React from 'react';
import clsx from 'clsx';
import { useBox } from '../Box';
import { useFlex } from '../Flex';
import { useText } from '../Text';
function Base(_ref) {
  var _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
    children = _ref.children,
    refCallback = _ref.refCallback,
    innerRef = _ref.innerRef,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var _useBox = useBox(extraProps),
    _useBox2 = _slicedToArray(_useBox, 2),
    boxClasses = _useBox2[0],
    boxExtra = _useBox2[1];
  var _useFlex = useFlex(boxExtra),
    _useFlex2 = _slicedToArray(_useFlex, 2),
    flexClasses = _useFlex2[0],
    flexExtra = _useFlex2[1];
  var _useText = useText(flexExtra),
    _useText2 = _slicedToArray(_useText, 2),
    textClasses = _useText2[0],
    textExtra = _useText2[1];
  return /*#__PURE__*/React.createElement(tagName, // $FlowFixMe[cannot-spread-inexact]
  _objectSpread({
    ref: innerRef || refCallback,
    className: clsx(boxClasses, flexClasses, textClasses, className)
  }, textExtra), children);
}
export default Base;